import mergeEntities from "./mergeEntities";
import { EntitiesProvider, EntitiesProviderProps, createEntitiesConsumer } from "./EntitiesContext";
import uuid from "../uuid";

export { mergeEntities, EntitiesProvider, EntitiesProviderProps, createEntitiesConsumer };

const CLIENT_ID_PREFIX = `c_`;

export function generateClientId() {
  return `${CLIENT_ID_PREFIX}${uuid()}`;
}

export function isClientId(id: string) {
  return id.startsWith(CLIENT_ID_PREFIX);
}



// WEBPACK FOOTER //
// ./frontend/src/lib/entities/index.ts